const selector = '.instafeed-new-layout-wrapper';
const initialized = new WeakSet();

function replaceLazyImages(feed) {
  feed.querySelectorAll('.instafeed-lazy-image').forEach((image) => {
    const source = image.getAttribute('data-instafeed-src');
    if (source) image.setAttribute('src', source);
    image.classList.remove('instafeed-lazy-image');
  });
}

function initializeFeed(track) {
  if (track.closest('[data-legacy-instafeed-clone]')) return;
  const feed = track.closest('#insta-feed') || track.parentElement;
  const host = feed?.parentElement;
  if (!feed || !host || initialized.has(feed) || feed.closest('.legacy-instafeed-marquee-belt')) return;
  if (!track.querySelector('img')) return;
  initialized.add(feed);

  const belt = document.createElement('div');
  belt.className = 'legacy-instafeed-marquee-belt';
  host.classList.add('legacy-instafeed-marquee-host');
  feed.before(belt);
  belt.append(feed);

  let frame;
  const rebuild = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!host.isConnected) {
        resizeObserver.disconnect();
        feedObserver.disconnect();
        return;
      }
      const width = feed.getBoundingClientRect().width;
      if (!width) return;
      belt.querySelectorAll('[data-legacy-instafeed-clone]').forEach((copy) => copy.remove());
      const copies = Math.max(1, Math.ceil(host.clientWidth / width));
      for (let index = 0; index < copies; index += 1) {
        const copy = feed.cloneNode(true);
        copy.setAttribute('data-legacy-instafeed-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        replaceLazyImages(copy);
        belt.append(copy);
      }
      belt.style.setProperty('--legacy-instafeed-distance', `${width}px`);
    });
  };

  const resizeObserver = new ResizeObserver(rebuild);
  resizeObserver.observe(host);
  resizeObserver.observe(feed);
  const feedObserver = new MutationObserver(rebuild);
  feedObserver.observe(feed, { childList: true, subtree: true });
  rebuild();
}

function initialize() {
  document.querySelectorAll(selector).forEach(initializeFeed);
}

initialize();
new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
